const normalizeNumber = value => {
    if (value === null || value === undefined || value === '') return null
    const normalized = String(value).replace(/,/g, '')
    const number = Number(normalized)
    return Number.isNaN(number) ? null : number
}

const sumField = (records, key) => {
    if (!Array.isArray(records) || records.length === 0) return null
    let total = 0
    let hasValue = false
    records.forEach(record => {
        const value = normalizeNumber(record ? record[key] : null)
        if (value !== null) {
            total += value
            hasValue = true
        }
    })
    return hasValue ? total : null
}

const countNonEmpty = (records, key) => {
    if (!Array.isArray(records) || records.length === 0) return null
    let count = 0
    records.forEach(record => {
        const raw = record ? record[key] : null
        if (raw !== null && raw !== undefined && String(raw).trim() !== '') {
            count += 1
        }
    })
    return count
}

export const buildTfDetailTotalsRow = records => {
    if (!Array.isArray(records) || records.length === 0) return null

    const barcodeCount = countNonEmpty(records, 'barcode')
    const purchaseTotal = sumField(records, 'purchase_mass')
    const dispatchTotal = sumField(records, 'Dispatched')
    const receivedTotal = sumField(records, 'Received')

    return {
        __summary: true,
        scanner_full_Name: 'Total',
        loaded_at: '',
        MarkedAs: '',
        barcode: barcodeCount || '',
        purchase_mass: purchaseTotal === null ? '' : purchaseTotal,
        Dispatched: dispatchTotal === null ? '' : dispatchTotal,
        received_by: '',
        received_at: '',
        Received: receivedTotal === null ? '' : receivedTotal,
    }
}

